import CloseIcon from '@mui/icons-material/Close';
import MaximizeIcon from '@mui/icons-material/Maximize';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useIntl } from 'react-intl';

interface MinimizedReportTabProps {
  title: string | undefined;
  onMaximize: () => void;
  onClose: () => void;
}

const MinimizedReportTab = ({
  title,
  onMaximize,
  onClose,
}: MinimizedReportTabProps) => {
  const intl = useIntl();
  const handleMaximizeClicked = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    onMaximize();
  };

  const handleTabClicked = () => {
    onMaximize();
  };

  const handleCloseClicked = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    onClose();
  };
  return (
    <Box
      sx={{
        width: '400px',
        backgroundColor: '#F6F6F6',
        boxShadow: 2,
        borderRadius: '6px 6px 0px 0px',
        position: 'fixed',
        bottom: 0,
        right: 100,
        transition: 'box-shadow 0.5s',
        zIndex: 100,
        '&:hover': {
          cursor: 'pointer',
          boxShadow: '0px 0px 12px 0px rgba(0, 0, 0, 0.28)',
        },
      }}
      onClick={handleTabClicked}
    >
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        padding='8px 8px 8px 20px'
      >
        <Typography fontWeight={500} fontSize={14}>
          {title ?? intl.formatMessage({ defaultMessage: 'Final Report' })}
        </Typography>
        <Stack direction='row' spacing={1}>
          <IconButton size='small' onClick={handleMaximizeClicked}>
            <MaximizeIcon />
          </IconButton>
          <IconButton size='small' onClick={handleCloseClicked}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </Stack>
    </Box>
  );
};

export default MinimizedReportTab;
